import { Injectable } from "@angular/core";
import { AppService } from "../../service/App.Service";

@Injectable({ providedIn: "root" })
export class DCSCustomService extends AppService<any> {
  constructor() {
    super("");
  }
}
